// we save these strings in the database and as the display labels
export const aoiOptions = [
    "Contracted AOI",
    "Buffered AOI",
    "Total Area Flown (TAF)",
    "Legacy AOI",
    "Corridor",
] as const
export type AoiType = (typeof aoiOptions)[number]

export const isAoiTypeCorridor = (aoi?: AoiType) => aoi === "Corridor"

export type AoiName = {
    aoi_id: number
    name: string
}
